<div *ngFor="let attachment of taskAttachments" class="attachment_item">
  <attachment-item
    [attachment]="attachment"
    [editPermissions]="editPermissions"
    (deleteAttachmentEvent)="onDeleteAttachment($event)"
  ></attachment-item>
</div>
